'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _immutable = require('immutable');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DialogManager = function (_React$Component) {
  (0, _inherits3.default)(DialogManager, _React$Component);

  function DialogManager() {
    (0, _classCallCheck3.default)(this, DialogManager);
    return (0, _possibleConstructorReturn3.default)(this, (DialogManager.__proto__ || (0, _getPrototypeOf2.default)(DialogManager)).apply(this, arguments));
  }

  (0, _createClass3.default)(DialogManager, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var selectedDialogs = this.props.selectedDialogs;


      var result = null;

      if (selectedDialogs && selectedDialogs.size > 0) {
        var resultArr = selectedDialogs.keySeq().toArray();
        result = resultArr.map(function (dialogId) {
          return _this2.props.getDialog(dialogId);
        });
      }

      return result;
    }
  }]);
  return DialogManager;
}(_react2.default.Component);

DialogManager.propTypes = {
  /**
   * Ordered map of selected Dialog to be shown
   */
  selectedDialogs: _propTypes2.default.instanceOf(_immutable.OrderedMap),
  /**
   * Factory for getting dialog based off dialogId
   */
  getDialog: _propTypes2.default.func.isRequired
};

exports.default = DialogManager;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/dialog/DialogManager.js
// module id = 326
// module chunks = 10